import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/Footer.css';

interface FooterProps {
  variant: 'container' | 'admin';
}

const Footer: React.FC<FooterProps> = ({ variant }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`footer-${variant}`}>
      <div className="content-wrap">
        <div className="footer-content">
          <div className="footer-brand">
            <strong>DentalPuente</strong>
            <span>Odontología profesional en Guadalajara.</span>
            <span className="copyright_text">© 2018-{currentYear} DentalPuente. Todos los derechos reservados.</span>
          </div>
          {variant === 'container' && (
            <div className="footer-meta" aria-label="Enlaces rápidos">
              <Link to="/About">Acerca de</Link><span className="footer-divider" aria-hidden="true" />
              <Link to="/Gallery">Galería</Link><span className="footer-divider" aria-hidden="true" />
              <Link to="/Contact">Contacto</Link>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
